import { mount } from "svelte";
import QejaExplore from "./qeja/QejaExplore.svelte";

function boot() {
  const el = document.getElementById("qeja-explore");
  if (!el) return;

  let center = [36.8219, -1.2921];
  try {
    center = JSON.parse(el.dataset.center || "null") || center;
  } catch {
    /* keep default */
  }

  const zoom = Number(el.dataset.zoom || 12);
  const filtersSelector = el.dataset.filtersSelector || "#vacancy-filters";
  const initialResults = el.querySelector("#qeja-initial-results");

  mount(QejaExplore, {
    target: el,
    props: {
      center,
      zoom,
      filtersSelector,
      initialResultsHtml: initialResults ? initialResults.innerHTML : "",
    },
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
